import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from '../app.settings';
import { RestApiService } from './rest-api.service';
import { UserCommonService } from './user-common.service';

@Injectable({
  providedIn: 'root'
})
export class PickupLocationOptionsService {

  constructor(
    private restApiService: RestApiService,
    private userCommonService: UserCommonService,
  ) {
  }

  getAllLocationOptions(queueLocationCatId: string, serviceAreaId: string, eventId: string, activatedOnly = false): Observable<any> {
    return this.restApiService.get(
      '/secure/locations?projection=grid&isLimit=false&' +
      `locationCategoryId=${queueLocationCatId}&eventId=${eventId}&serviceAreaId=${serviceAreaId}` +
      (activatedOnly ? '&activated=true' : ''),
      'page-center',
    );
  }

  /**
   * Location rows for pickup filter (queue, other, stay, parking categories) for the given service area and event.
   */
  getPickupAddress(serviceAreaId: string, eventId: string, activatedOnly = false): Observable<any[]> {
    if (!this.userCommonService.userMetaData?.locationCategorisList) {
      return of([]);
    }
    const locationCatIdsRecords = this.userCommonService.userMetaData.locationCategorisList.filter(
      cat => cat.id === AppSettings.All_LOCATION_TYPES.QUEUE
        || cat.id === AppSettings.All_LOCATION_TYPES.OTHER_LOCATION
        || cat.id === AppSettings.All_LOCATION_TYPES.STAY_LOCATION
        || cat.id === AppSettings.All_LOCATION_TYPES.PARKING
        || cat.id === AppSettings.All_LOCATION_TYPES.TRAIN_LOCATION
    );
    const locationCatIds = locationCatIdsRecords.map(cat => cat.id).join(',');
    return this.getAllLocationOptions(locationCatIds, serviceAreaId, eventId, activatedOnly).pipe(
      map(result => result?.data ?? []),
    );
  }
}